import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'mai-chatia-thinking',
  imports: [LottieComponent],
  templateUrl: './chat-thinking.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatAIthinkingComponent {
  isThinking = input(false, { transform: booleanAttribute });
  iconeThinking = input<string>('./lottie/load-dots.json');

  options = computed<AnimationOptions>(() => ({
    path: this.iconeThinking(),
  }));
}
